import { customElement, property, state } from 'lit/decorators.js';
import {html, LitElement} from "lit";
import {accordionStyles} from "@/components/accordion/accordion.styles";

/**
 * @slot default - Inhalt
 */
@customElement('sbk-accordion')
export class SbkAccordion extends LitElement {

    @property()
    heading = '';

    @state()
    _expanded = false

    static get styles() {
        return accordionStyles;
    }

    _toggle() {
        this._expanded = !this._expanded
    }

    render() {
        return html`
            <dl class="accordion-container">
                <dt>
                    <button id="accordion-header"
                            @click=${this._toggle}
                            aria-controls="accordion-panel"
                            aria-expanded=${this._expanded}>
                        ${this.heading}
                        <sbk-icon size="32" symbol="chevron-down"></sbk-icon>
                    </button>
                </dt>
                <dd id="accordion-panel"
                    aria-labelledby="accordion-header"
                    ?hidden=${!this._expanded}>
                    <slot></slot>
                </dd>
            </dl>
        `;
    }
}
